export const WINDOW_OPTIONS = [6, 24, 72, 168];

export const DEVICE_COLORS = ["#2bd9a8", "#ffb547", "#4aa3ff", "#ff6b86"];

export const METRIC_TRENDS = [
  { key: "inside_wellness_score", label: "Inside Wellness", shortLabel: "Wellness", unit: "score", digits: 0, color: "#2bd9a8" },
  { key: "co2_ppm", label: "Carbon Dioxide", shortLabel: "CO2", unit: "ppm", digits: 0, color: "#4aa3ff" },
  { key: "tvoc_ugm3", label: "TVOC", shortLabel: "TVOC", unit: "ug/m3", digits: 0, color: "#c08cff" },
  { key: "pm25_ugm3", label: "PM2.5", shortLabel: "PM2.5", unit: "ug/m3", digits: 1, color: "#ff6b86" },
  { key: "temp_c", label: "Temperature", shortLabel: "Temp", unit: "C", digits: 1, color: "#ffb547" },
  { key: "humidity_pct", label: "Humidity", shortLabel: "Humidity", unit: "%", digits: 0, color: "#35c7e8" },
  { key: "noise_dba", label: "Noise", shortLabel: "Noise", unit: "dBA", digits: 0, color: "#ff8c3a" },
  { key: "light_lux", label: "Light", shortLabel: "Light", unit: "lux", digits: 0, color: "#f4d35e" }
] as const;

export const PROMPT_BUTTONS = [
  "Which Wellcube has the best air quality?",
  "Why did the wellness score drop?",
  "What should I say in a demo?",
  "Which signals need attention first?"
];

export const SOURCE_CARDS = [
  {
    category: "Telemetry",
    title: "Local Wellcube CSV Exports",
    kind: "real",
    description: "Ignored local CSV files under data/ are normalized into Elasticsearch readings.",
    usage: "Device timestamps, occupancy, temperature, humidity, air quality, light, comfort, workspace scores, and noise."
  },
  {
    category: "Storage",
    title: "Elasticsearch wellcube_readings",
    kind: "real",
    description: "The backend queries normalized readings from the local Compose Elasticsearch service.",
    usage: "Windowed insight reads, trends, replay snapshots, freshness, and device comparisons."
  },
  {
    category: "Derived Intelligence",
    title: "Inside Wellness Scoring",
    kind: "modeled",
    description: "Application-derived demo logic weights air quality, comfort, noise, occupied light, freshness, and completeness.",
    usage: "Room score, component bars, anomaly context, and demo talking points."
  },
  {
    category: "Assistant",
    title: "OpenAI Responses API",
    kind: "configured",
    description: "Server-side chat sends compact Wellcube context and optional trusted MCP/web-search tools.",
    usage: "Natural-language answers, source transparency, and demo guidance."
  },
  {
    category: "Outside Context",
    title: "Localized Open-Meteo Backfill",
    kind: "configured",
    description: "Hourly localized weather and air-quality context can be backfilled into a separate Elasticsearch index.",
    usage: "Indoor/outdoor temperature, humidity, particulate, AQI, source transparency, and future realtime weather context."
  }
];
